<template>
  <path
    fill="currentColor"
    d="M15.625 2.5C15.625 2.15483 15.3452 1.875 15 1.875C14.6548 1.875 14.375 2.15482 14.375 2.5L14.375 10.0011C14.375 12.4171 12.4164 14.375 10 14.375C7.58358 14.375 5.625 12.4171 5.625 10.0011L5.62501 2.5C5.62501 2.15483 5.34519 1.875 5.00001 1.875C4.65483 1.875 4.37501 2.15482 4.37501 2.5L4.375 10.0011C4.375 13.1078 6.89357 15.625 10 15.625C13.1064 15.625 15.625 13.1078 15.625 10.0011L15.625 2.5Z" />
  <path
    fill="currentColor"
    d="M3.75 16.875C3.40482 16.875 3.125 17.1548 3.125 17.5C3.125 17.8452 3.40482 18.125 3.75 18.125H16.25C16.5952 18.125 16.875 17.8452 16.875 17.5C16.875 17.1548 16.5952 16.875 16.25 16.875H3.75Z" />
</template>
